function PatientVO(id, fileNumber, firstName, lastName, identityDocumentNumber, nipNumber, companyNip, phone,
                   emailPermission, email, createDate, birthDate, identityDocumentType, identifier, identifierType,
                   gender, registeredAddress, correspondenceAddress, authorizedPersons, notes, citizenship,
                   visits, nfzOffice, knowledgeDatabasePermission, knowledgeDatabaseWeight, attachments, correspondenceAddressSameAsRegisteredAddress,
                   guardians, hasVisits, toBeVerified, meedyDoctorsSmsAllowed) {

    this.id = id;
    this.fileNumber = fileNumber;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.notes = notes;
    this.citizenship = citizenship;
    this.identityDocumentNumber = identityDocumentNumber;
    this.nipNumber = nipNumber;
    this.companyNip = companyNip;
    this.phone = phone;
    this.emailPermission = emailPermission === true;
    this.createDate = createDate;
    this.birthDate = birthDate;
    this.gender = gender;
    this.identityDocumentType = identityDocumentType;
    this.identifier = identifier;
    this.identifierType = identifierType;
    this.registeredAddress = registeredAddress;
    this.correspondenceAddress = correspondenceAddress;
    this.authorizedPersons = authorizedPersons;
    this.nfzOffice = nfzOffice;
    this.visits = visits;
    this.knowledgeDatabasePermission = knowledgeDatabasePermission;
    this.knowledgeDatabaseWeight = knowledgeDatabaseWeight;
    this.attachments = attachments;
    this.correspondenceAddressSameAsRegisteredAddress = correspondenceAddressSameAsRegisteredAddress;
    this.guardians = guardians;
    this.hasVisits = hasVisits;
    this.toBeVerified = toBeVerified;
    this.meedyDoctorsSmsAllowed = meedyDoctorsSmsAllowed;

    var _typeContext = {
        createDate: Date,
        birthDate: Date,
        citizenship: DictionaryElementVO,
        registeredAddress: AddressVO,
        correspondenceAddress: AddressVO,
        authorizedPersons: AuthorizedPersonVO,
        nfzOffice: NfzOfficeVO,
        visits: VisitVO,
        attachments: AttachmentVO,
        guardians: GuardianVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}


PatientVO.prototype.getFullName = function () {
    return this.firstName + ' ' + this.lastName;
};
